/** An accounting hold is not a human decision to exclude a bank transaction. */
export function isBankFeedAwaitingReview(row: {
  externalSource?: string | null; reviewedAt?: unknown; excludedAt?: unknown; voidedAt?: unknown;
}) {
  return row.externalSource === "stripe_bank" && !!row.excludedAt && !row.reviewedAt && !row.voidedAt;
}
